{
  "schemaVersion": 2,
  "id": "lobby-friends",
  "stage": {
    "w": 941,
    "h": 1672
  },
  "units": "stage units; PNG slice values are source pixels at 2x",
  "sourceRoot": "repository root",
  "reference": "art/src/lobby-elements-2026-09-22/friends-lobby-mockup.png",
  "defaultState": "host_waiting",
  "defaultExample": "host_waiting",
  "theme": {
    "id": "friends",
    "cyanFilter": "hue-rotate(200deg) saturate(1.2)"
  },
  "textContract": {
    "renderer": "Ink role / static HTML+CSS lane (OD-035/036)",
    "position": "x/y/w/h is the fixed lane; capCenterY is the optical capital-height centre",
    "sizing": "Only role defaults determine font size. No per-word cap/font-size override, no enlargement, no runtime JS measurements.",
    "ordinaryOverflow": "Names: CSS text-overflow ellipsis. Ordinary labels retain role size and use the provided full lane.",
    "codeMaxW": "Code alone may fit uniformly down to maxW under BRIEF-FRIENDS; never enlarge or distort it. The preview code fits at role code=100. Presentation remains CSS-owned; no DOM measurement or JS style rewriting.",
    "roles": {
      "eyebrow": {
        "font": "Nunito",
        "size": 26,
        "weight": 600,
        "trackingEm": 0.18,
        "lineHeight": 33
      },
      "body": {
        "font": "Nunito",
        "size": 30,
        "weight": 500,
        "trackingEm": 0,
        "lineHeight": 38
      },
      "caption": {
        "font": "Nunito",
        "size": 26,
        "weight": 500,
        "trackingEm": 0,
        "lineHeight": 33
      },
      "chip": {
        "font": "Nunito",
        "size": 24,
        "weight": 700,
        "trackingEm": 0,
        "lineHeight": 35
      },
      "status": {
        "font": "Barlow Condensed",
        "size": 26,
        "weight": 700,
        "trackingEm": 0,
        "lineHeight": 33
      },
      "code": {
        "font": "Nunito",
        "size": 100,
        "weight": 900,
        "trackingEm": 0.02,
        "lineHeight": 125
      },
      "button": {
        "font": "Nunito",
        "size": 32,
        "weight": 800,
        "trackingEm": 0,
        "lineHeight": 40
      },
      "action": {
        "font": "Nunito",
        "size": 56,
        "weight": 400,
        "trackingEm": 0,
        "lineHeight": 70
      }
    }
  },
  "colors": {
    "white": "#ffffff",
    "gold": "#ffe36a",
    "host": "#ffd84a",
    "ready": "#4ff08a",
    "offline": "#8f9ac4",
    "onGold": "#17120a"
  },
  "textClasses": {
    "gold": {
      "color": "#ffe36a"
    },
    "host": {
      "color": "#ffd84a"
    },
    "ready": {
      "color": "#4ff08a"
    },
    "offline": {
      "color": "#8f9ac4"
    },
    "on-gold": {
      "color": "#17120a"
    },
    "friends-code-gold": {
      "gradient": {
        "direction": "180deg",
        "stops": [
          [
            0,
            "#facf63"
          ],
          [
            0.5,
            "#fde599"
          ],
          [
            1,
            "#fbeebd"
          ]
        ]
      },
      "applyTo": "text only; CSS background-clip text"
    }
  },
  "pieces": {
    "art/src/lobby-backgrounds-2026-09-22/friends.png": {
      "path": "art/src/lobby-backgrounds-2026-09-22/friends.png",
      "pixelW": 941,
      "pixelH": 1672,
      "alpha": false,
      "sha256": "5f0ba22c8354bedb837806daf9269877ef3a7c29edae44504588e08bfa2c4e3b",
      "reused": true
    },
    "apps/client/public/art/room-logos/lobby-friends.png": {
      "path": "apps/client/public/art/room-logos/lobby-friends.png",
      "pixelW": 880,
      "pixelH": 500,
      "alpha": true,
      "sha256": "00944ff4a68a8ee16ccd9cd0d884e04e4095843dc2aea32cf8ca0f08cbda6f78",
      "reused": true
    },
    "apps/client/public/art/ui-head/bg@2x.png": {
      "path": "apps/client/public/art/ui-head/bg@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "sha256": "ed70ede39d5d34e59c6619b7d84082814b69058bbd929b4ce0d895185220f820",
      "reused": true
    },
    "apps/client/public/art/ui-head/icon-back@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-back@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "sha256": "026c480685d45fca3639e55537d5a3d3557f3ffb72cfbbf6e6e84354ad954694",
      "reused": true
    },
    "apps/client/public/art/ui-head/icon-sound-on@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-sound-on@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "sha256": "4cbe7e8ec9c7d9ab1dc14c1046c12fe03684e9fc1853b3514e18acbc014671ff",
      "reused": true
    },
    "sticker.ul.png": {
      "path": "art/src/lobby-elements-2026-09-22/sticker.ul.png",
      "pixelW": 328,
      "pixelH": 308,
      "alpha": true,
      "sha256": "54f64ea3c8e610d9681118192d797074b5f005d3f3b570cf75d4760c1678660d",
      "reused": true
    },
    "sticker.ur.png": {
      "path": "art/src/lobby-elements-2026-09-22/sticker.ur.png",
      "pixelW": 396,
      "pixelH": 308,
      "alpha": true,
      "sha256": "0112673e6dbd9a38ab1c48d9a523973d6ccba02b38e3dd02cc6edd7728cd8f8e",
      "reused": true
    },
    "board9.png": {
      "path": "art/src/lobby-elements-2026-09-22/board9.png",
      "pixelW": 640,
      "pixelH": 640,
      "alpha": true,
      "sha256": "ff3a8f9078435101fdc3c4ce5d5ecdaa17e6de5999278710861bf503700665fb",
      "slicePx": {
        "top": 128,
        "right": 128,
        "bottom": 128,
        "left": 128
      },
      "cornerKStage": 64,
      "reused": true
    },
    "leaf.l.png": {
      "path": "art/src/lobby-elements-2026-09-22/leaf.l.png",
      "pixelW": 240,
      "pixelH": 320,
      "alpha": true,
      "sha256": "94b315d93178bcbfbdacf34d3a3cf61c74939a10126c65197df4a6e6c1b2d649",
      "reused": true
    },
    "leaf.r.png": {
      "path": "art/src/lobby-elements-2026-09-22/leaf.r.png",
      "pixelW": 240,
      "pixelH": 320,
      "alpha": true,
      "sha256": "b4b422e794877779e552f9b60dfa1a87abb6e652b03d67cc11e3c27b35bde66a",
      "reused": true
    },
    "icon.clock.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.clock.png",
      "pixelW": 80,
      "pixelH": 80,
      "alpha": true,
      "sha256": "5617a2e8154691b49305170c56d2af023670f67e7379dac5f015518d9362a29b",
      "reused": true
    },
    "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp": {
      "path": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "sha256": "b4bdaaa8028ddd65a6e322f0967ef7547cf485f3ccf98af7e7dfd8306a3df62b",
      "reused": true
    },
    "host.ring.png": {
      "path": "art/src/lobby-elements-2026-09-22/host.ring.png",
      "pixelW": 520,
      "pixelH": 440,
      "alpha": true,
      "sha256": "004db57a142f9906048aeca455404b5da379786f6a1a55b679d69039cd52b33b",
      "reused": true
    },
    "tag.host.png": {
      "path": "art/src/lobby-elements-2026-09-22/tag.host.png",
      "pixelW": 400,
      "pixelH": 92,
      "alpha": true,
      "sha256": "cfab4cfe9bb7a6d646307b0929987c25d5e8ce2819972d5565f4b7943124e52f",
      "slicePx": {
        "left": 50,
        "right": 50,
        "top": 0,
        "bottom": 0
      },
      "reused": true
    },
    "crown.png": {
      "path": "art/src/lobby-elements-2026-09-22/crown.png",
      "pixelW": 140,
      "pixelH": 100,
      "alpha": true,
      "sha256": "f60b2ad1d395d974e8adc9b94cb3ccbc6823250b0d3de4019af7298738fd687a",
      "reused": true
    },
    "pill.short.png": {
      "path": "art/src/lobby-elements-2026-09-22/pill.short.png",
      "pixelW": 400,
      "pixelH": 128,
      "alpha": true,
      "sha256": "fed3d6d3a56ba5abf42980b9af2eac1bb4818098e816cff2c87dfd9302584dc9",
      "slicePx": {
        "left": 70,
        "right": 70,
        "top": 0,
        "bottom": 0
      },
      "reused": true
    },
    "open.ring.png": {
      "path": "art/src/lobby-elements-2026-09-22/open.ring.png",
      "pixelW": 520,
      "pixelH": 412,
      "alpha": true,
      "sha256": "231723111d9a140fe4bcb298b231aa27b8b02e232b123426555733c16ba53025",
      "reused": true
    },
    "copy.button.png": {
      "path": "art/src/lobby-elements-2026-09-22/copy.button.png",
      "pixelW": 432,
      "pixelH": 228,
      "alpha": true,
      "sha256": "70edf82723155f17b95852b0aef39dc695f05f2a26a3b77dec1dd8e365a297ad",
      "slicePx": {
        "left": 125,
        "right": 125,
        "top": 0,
        "bottom": 0
      },
      "reused": true
    },
    "icon.copy.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.copy.png",
      "pixelW": 120,
      "pixelH": 120,
      "alpha": true,
      "sha256": "d733e1cea481ec48ecb54c77c1a32fa845d9c1802ef5e2b7a7899a079527e5d1",
      "reused": true
    },
    "cta.plate.png": {
      "path": "art/src/lobby-elements-2026-09-22/cta.plate.png",
      "pixelW": 1736,
      "pixelH": 326,
      "alpha": true,
      "sha256": "ae9529479f4f35a908b8acd3f2e196be029ae229eb90d3b4dc969e7d8e7dcdde",
      "slicePx": {
        "left": 331,
        "right": 331,
        "top": 0,
        "bottom": 0
      },
      "reused": true
    },
    "icon.people.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.people.png",
      "pixelW": 140,
      "pixelH": 140,
      "alpha": true,
      "sha256": "ef41c39512f5c508dc3e871a6f7a96edfd6f342a1f17c152be0f3d55de3500e0",
      "reused": true
    },
    "small.button.png": {
      "path": "art/src/lobby-elements-2026-09-22/small.button.png",
      "pixelW": 812,
      "pixelH": 228,
      "alpha": true,
      "sha256": "c0a274c1d527673a77055107fae0cbd3149ec8fbbe9fb2128129515ba86479ed",
      "slicePx": {
        "left": 229,
        "right": 229,
        "top": 0,
        "bottom": 0
      },
      "reused": true
    },
    "icon.book.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.book.png",
      "pixelW": 192,
      "pixelH": 192,
      "alpha": true,
      "sha256": "187c91e21438fcdef7e0c8af970f174dbab6d94f4c9666f8c35784c9f079713d",
      "reused": true
    },
    "icon.gear.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.gear.png",
      "pixelW": 140,
      "pixelH": 140,
      "alpha": true,
      "sha256": "a2c54c7c031704802afd6b53aa3c8881a84c94afbe4df77cc7b50ea8c36d9142",
      "reused": true
    },
    "seat.ring.png": {
      "path": "art/src/lobby-elements-2026-09-22/seat.ring.png",
      "pixelW": 520,
      "pixelH": 440,
      "alpha": true,
      "sha256": "a877661bef9d18762c7047a1d42578936b0cb112c960190d7e70590617eb57af",
      "reused": true
    },
    "icon.door.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.door.png",
      "pixelW": 140,
      "pixelH": 140,
      "alpha": true,
      "sha256": "ebfd41dcad51e61ecfb63d4feebc6f64dc3f87ae9077dcc50329a6a3691d0072",
      "reused": true
    },
    "apps/client/public/art/ui-head/icon-sound-off@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-sound-off@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "sha256": "25814b1deba5c0188b2840bb696bc15f34d5fbaeaf21f049790b4b13e2d0b249",
      "reused": true
    },
    "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp": {
      "path": "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "sha256": "f75ed324dfe890fd03136dfd43898d0c24b526d648e6655bce2303e136e3c004",
      "reused": true
    },
    "icon.gear.solid.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.gear.solid.png",
      "pixelW": 640,
      "pixelH": 640,
      "alpha": true,
      "source": "the owner's /var/www/play.saynoway.com/icons/gear-solid.png (fa-solid gear), 23.9.2026"
    },
    "icon.info.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.info.png",
      "pixelW": 640,
      "pixelH": 640,
      "alpha": true,
      "source": "the owner's /var/www/play.saynoway.com/icons/circle-info-solid.png (fa-solid circle-info), 23.9.2026"
    },
    "icon.thumbs.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.thumbs.png",
      "pixelW": 640,
      "pixelH": 640,
      "alpha": true,
      "source": "the owner's /var/www/play.saynoway.com/icons/thumbs-up-solid.png, 23.9.2026"
    },
    "ready.badge.png": {
      "path": "art/src/lobby-elements-2026-09-22/ready.badge.png",
      "pixelW": 224,
      "pixelH": 224,
      "alpha": true,
      "source": "Codex round 2 (ready-badge/ready.badge-2.png) on the owner's words, 23.9.2026"
    },
    "icon.question.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.question.png",
      "pixelW": 640,
      "pixelH": 640,
      "alpha": true,
      "source": "the owner's /var/www/play.saynoway.com/icons/question-solid.png (fa-solid question), 23.9.2026"
    }
  },
  "elements": [
    {
      "id": "background",
      "piece": "art/src/lobby-backgrounds-2026-09-22/friends.png",
      "x": 0,
      "y": 0,
      "w": 941,
      "h": 1672,
      "render": "image",
      "tint": "none",
      "z": 0
    },
    {
      "id": "logo",
      "piece": "apps/client/public/art/room-logos/lobby-friends.png",
      "x": 267,
      "y": 8,
      "w": 440,
      "h": 250,
      "render": "image",
      "tint": "none",
      "z": 60
    },
    {
      "id": "back.button",
      "piece": "apps/client/public/art/ui-head/bg@2x.png",
      "x": 16,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 60,
      "mirrorX": false
    },
    {
      "id": "back.icon",
      "piece": "apps/client/public/art/ui-head/icon-back@2x.png",
      "x": 16,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 61
    },
    {
      "id": "sound.button",
      "piece": "apps/client/public/art/ui-head/bg@2x.png",
      "x": 812,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 60,
      "mirrorX": true
    },
    {
      "id": "sound.icon",
      "piece": "apps/client/public/art/ui-head/icon-sound-on@2x.png",
      "x": 812,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 61
    },
    {
      "id": "sticker.ul",
      "piece": "sticker.ul.png",
      "x": 25,
      "y": 142,
      "w": 171,
      "h": 160.573,
      "render": "image",
      "tint": "none",
      "z": 10
    },
    {
      "id": "sticker.ur",
      "piece": "sticker.ur.png",
      "x": 763,
      "y": 143,
      "w": 174,
      "h": 135.333,
      "render": "image",
      "tint": "none",
      "z": 10
    },
    {
      "id": "status.plate",
      "piece": "board9.png",
      "x": 150.5,
      "y": 259.5,
      "w": 639.5,
      "h": 193.5,
      "render": "border-image",
      "tint": "cyan",
      "z": 20,
      "slicePx": {
        "top": 128,
        "right": 128,
        "bottom": 128,
        "left": 128
      },
      "borderWidthStage": 64,
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "interactive": false,
      "referenceTubeBox": {
        "x": 170,
        "y": 259,
        "w": 600,
        "h": 154
      }
    },
    {
      "id": "status.leaf.l",
      "piece": "leaf.l.png",
      "x": 173,
      "y": 325,
      "w": 80,
      "h": 106.667,
      "render": "image",
      "tint": "cyan",
      "z": 21,
      "opacity": 0.24
    },
    {
      "id": "status.leaf.r",
      "piece": "leaf.r.png",
      "x": 687,
      "y": 325,
      "w": 80,
      "h": 106.667,
      "render": "image",
      "tint": "cyan",
      "z": 21,
      "opacity": 0.24
    },
    {
      "id": "status.clock",
      "piece": "icon.clock.png",
      "x": 319,
      "y": 382,
      "w": 32,
      "h": 32,
      "render": "image",
      "tint": "none",
      "z": 30
    },
    {
      "id": "seat1.avatar",
      "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
      "x": 119,
      "y": 495,
      "w": 204,
      "h": 204,
      "render": "image",
      "tint": "none",
      "z": 18,
      "clip": "circle",
      "sourceCrop": {
        "x": 24,
        "y": 0,
        "w": 208,
        "h": 208
      },
      "opacity": 1,
      "binding": {
        "kind": "player-avatar-expression",
        "seat": 1,
        "fallbackAvatarId": "snw-cast-0056"
      }
    },
    {
      "id": "seat1.ring",
      "piece": "host.ring.png",
      "x": 77.277,
      "y": 475.154,
      "w": 288,
      "h": 243.692,
      "render": "image",
      "tint": "none",
      "z": 20,
      "opacity": 1,
      "referenceCenter": {
        "x": 221,
        "y": 597
      }
    },
    {
      "id": "seat1.pill",
      "piece": "pill.short.png",
      "x": 131,
      "y": 650,
      "w": 180,
      "h": 60,
      "render": "3-slice",
      "tint": "cyan",
      "z": 23,
      "slicePx": {
        "left": 70,
        "right": 70,
        "top": 0,
        "bottom": 0
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "opacity": 1
    },
    {
      "id": "seat2.ring",
      "piece": "open.ring.png",
      "x": 319.871,
      "y": 482.191,
      "w": 298.834,
      "h": 236.768,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "referenceCenter": {
        "x": 469,
        "y": 600
      },
      "referenceRadius": 101
    },
    {
      "id": "seat3.ring",
      "piece": "open.ring.png",
      "x": 566.871,
      "y": 483.191,
      "w": 298.834,
      "h": 236.768,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "referenceCenter": {
        "x": 716,
        "y": 601
      },
      "referenceRadius": 101
    },
    {
      "id": "seat4.ring",
      "piece": "open.ring.png",
      "x": 70.394,
      "y": 730.024,
      "w": 301.792,
      "h": 239.112,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "referenceCenter": {
        "x": 221,
        "y": 849
      },
      "referenceRadius": 102
    },
    {
      "id": "seat5.ring",
      "piece": "open.ring.png",
      "x": 316.394,
      "y": 730.024,
      "w": 301.792,
      "h": 239.112,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "referenceCenter": {
        "x": 467,
        "y": 849
      },
      "referenceRadius": 102
    },
    {
      "id": "seat6.ring",
      "piece": "open.ring.png",
      "x": 564.394,
      "y": 731.024,
      "w": 301.792,
      "h": 239.112,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "referenceCenter": {
        "x": 715,
        "y": 850
      },
      "referenceRadius": 102
    },
    {
      "id": "codebox.plate",
      "piece": "board9.png",
      "x": 46.5,
      "y": 990,
      "w": 847.5,
      "h": 260,
      "render": "border-image",
      "tint": "cyan",
      "z": 20,
      "slicePx": {
        "top": 128,
        "right": 128,
        "bottom": 128,
        "left": 128
      },
      "borderWidthStage": 64,
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "interactive": false,
      "referenceTubeBox": {
        "x": 66,
        "y": 964,
        "w": 808,
        "h": 180
      }
    },
    {
      "id": "code.leaf.l",
      "piece": "leaf.l.png",
      "x": 78,
      "y": 1020.5,
      "w": 120,
      "h": 160,
      "render": "image",
      "tint": "cyan",
      "z": 21,
      "opacity": 0.24
    },
    {
      "id": "code.leaf.r",
      "piece": "leaf.r.png",
      "x": 744,
      "y": 1020.5,
      "w": 120,
      "h": 160,
      "render": "image",
      "tint": "cyan",
      "z": 21,
      "opacity": 0.24
    },
    {
      "id": "copy.button",
      "piece": "copy.button.png",
      "x": 602.854,
      "y": 1062,
      "w": 235,
      "h": 111.22,
      "render": "3-slice",
      "tint": "cyan",
      "z": 24,
      "slicePx": {
        "left": 125,
        "right": 125,
        "top": 0,
        "bottom": 0
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "referenceTubeBox": {
        "x": 617,
        "y": 1019,
        "w": 199,
        "h": 80
      }
    },
    {
      "id": "copy.icon",
      "piece": "icon.copy.png",
      "x": 643,
      "y": 1096.61,
      "w": 44,
      "h": 44,
      "render": "image",
      "tint": "none",
      "z": 30
    },
    {
      "id": "cta.plate",
      "piece": "cta.plate.png",
      "x": 42.163,
      "y": 1260,
      "w": 855.191,
      "h": 157.155,
      "render": "3-slice",
      "tint": "none",
      "z": 30,
      "slicePx": {
        "left": 331,
        "right": 331,
        "top": 0,
        "bottom": 0
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "referenceTubeBox": {
        "x": 60,
        "y": 1195,
        "w": 820,
        "h": 121
      }
    },
    {
      "id": "cta.people",
      "piece": "icon.people.png",
      "x": 177,
      "y": 1294,
      "w": 88,
      "h": 88,
      "render": "image",
      "tint": "none",
      "z": 40,
      "colorTreatment": "on-gold",
      "filter": "brightness(0)"
    },
    {
      "id": "cta.thumbs",
      "piece": "icon.thumbs.png",
      "x": 265,
      "y": 1298,
      "w": 80,
      "h": 80,
      "render": "image",
      "tint": "none",
      "z": 40,
      "colorTreatment": "on-gold",
      "filter": "brightness(0)",
      "note": "I'M READY: the thumbs-up before the word, in INVITE FRIENDS' icon slot (owner 23.9.2026)"
    },
    {
      "id": "cta.caption.icon",
      "piece": "icon.people.png",
      "x": 265,
      "y": 1429,
      "w": 50,
      "h": 50,
      "render": "image",
      "tint": "none",
      "z": 35
    },
    {
      "id": "howto.button",
      "piece": "small.button.png",
      "x": 45.684,
      "y": 1500,
      "w": 423.088,
      "h": 104,
      "render": "3-slice",
      "tint": "cyan",
      "z": 30,
      "slicePx": {
        "left": 229,
        "right": 229,
        "top": 0,
        "bottom": 0
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "referenceTubeBox": {
        "x": 58,
        "y": 1400,
        "w": 398,
        "h": 78
      }
    },
    {
      "id": "howto.icon",
      "piece": "icon.info.png",
      "x": 109,
      "y": 1526,
      "w": 50,
      "h": 50,
      "render": "image",
      "tint": "none",
      "z": 40,
      "sourceFilter": "brightness(0) invert(1)"
    },
    {
      "id": "settings.button",
      "piece": "small.button.png",
      "x": 472.684,
      "y": 1500,
      "w": 424.088,
      "h": 104,
      "render": "3-slice",
      "tint": "cyan",
      "z": 30,
      "slicePx": {
        "left": 229,
        "right": 229,
        "top": 0,
        "bottom": 0
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "referenceTubeBox": {
        "x": 485,
        "y": 1400,
        "w": 399,
        "h": 78
      }
    },
    {
      "id": "settings.icon",
      "piece": "icon.gear.solid.png",
      "x": 522,
      "y": 1528,
      "w": 50,
      "h": 50,
      "render": "image",
      "tint": "none",
      "z": 40,
      "sourceFilter": "brightness(0) invert(1)"
    }
  ],
  "texts": [
    {
      "id": "status.heading",
      "text": "WAITING FOR YOUR CREW",
      "role": "eyebrow",
      "className": "t-eyebrow gold",
      "x": 208,
      "y": 298,
      "w": 524,
      "h": 33,
      "capCenterY": 314.5,
      "maxW": 524,
      "align": "center",
      "color": "#ffe36a",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "status.body",
      "text": "1 of 6 joined • 5 seats open",
      "role": "body",
      "className": "t-body",
      "x": 250,
      "y": 338,
      "w": 440,
      "h": 38,
      "capCenterY": 357,
      "maxW": 440,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "spans": [
        {
          "text": "1",
          "binding": "joinedCount",
          "color": "#ffe36a"
        },
        {
          "text": " of ",
          "color": "#ffffff"
        },
        {
          "text": "6",
          "binding": "capacity",
          "color": "#ffe36a"
        },
        {
          "text": " joined • ",
          "color": "#ffffff"
        },
        {
          "text": "5",
          "binding": "openSeatCount",
          "color": "#ffe36a"
        },
        {
          "text": " seats open",
          "color": "#ffffff"
        }
      ],
      "binding": {
        "kind": "seat-counts",
        "capacity": 6,
        "joinedCount": 1,
        "openSeatCount": 5,
        "joinOneLine": true
      },
      "composition": "One centred text lane; only numeral spans are gold. All spans inherit body role size/weight."
    },
    {
      "id": "status.timer",
      "text": "Invites open for 05:36",
      "role": "caption",
      "className": "t-caption",
      "x": 360,
      "y": 384,
      "w": 264,
      "h": 33,
      "capCenterY": 400.5,
      "maxW": 264,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "binding": {
        "kind": "invite-countdown",
        "example": "05:36",
        "expired": "Invites closed"
      },
      "group": {
        "id": "invite-window",
        "centerX": 470,
        "icon": "status.clock",
        "gap": 8
      }
    },
    {
      "id": "seat1.status",
      "text": "HOST",
      "role": "status",
      "className": "t-status host",
      "x": 161,
      "y": 451,
      "w": 120,
      "h": 33,
      "capCenterY": 467.5,
      "maxW": 120,
      "align": "center",
      "color": "#ffd84a",
      "z": 46,
      "overflow": "visible",
      "size": 30
    },
    {
      "id": "seat1.name",
      "text": "YOU",
      "role": "chip",
      "className": "t-chip",
      "x": 163,
      "y": 664,
      "w": 116,
      "h": 35,
      "capCenterY": 681.5,
      "maxW": 116,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "ellipsis",
      "binding": {
        "kind": "player-name",
        "seat": 1,
        "selfLabel": "YOU",
        "fallback": "Player",
        "maxChars": null,
        "overflow": "CSS ellipsis; never shrink glyphs"
      }
    },
    {
      "id": "code.heading",
      "text": "ROOM CODE",
      "role": "eyebrow",
      "className": "t-eyebrow",
      "x": 150,
      "y": 1036,
      "w": 374,
      "h": 33,
      "capCenterY": 1052.5,
      "maxW": 374,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 30
    },
    {
      "id": "code.value",
      "text": "S4PKPU",
      "role": "code",
      "className": "t-code friends-code-gold",
      "x": 115,
      "y": 1065,
      "w": 430,
      "h": 125,
      "capCenterY": 1127.5,
      "maxW": 430,
      "align": "center",
      "color": "#ffe36a",
      "z": 46,
      "overflow": "code-maxW",
      "gradient": {
        "direction": "180deg",
        "stops": [
          [
            0,
            "#facf63"
          ],
          [
            0.5,
            "#fde599"
          ],
          [
            1,
            "#fbeebd"
          ]
        ]
      },
      "binding": {
        "kind": "room-code",
        "length": 6,
        "example": "S4PKPU"
      },
      "fit": "code-only maxW; no upscaling",
      "codeOverflow": {
        "maxW": 430,
        "allowedException": "Brief permits code-only uniform fit within maxW; no distortion, no upscaling. No runtime DOM measuring or per-label JS styles."
      },
      "size": 90
    },
    {
      "id": "code.url",
      "text": "play.saynoway.com/r/S4PKPU",
      "role": "caption",
      "className": "t-caption",
      "x": 120,
      "y": 1175,
      "w": 700,
      "h": 33,
      "capCenterY": 1191.5,
      "maxW": 700,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "binding": {
        "kind": "room-url",
        "fullValue": "play.saynoway.com/r/S4PKPU"
      },
      "note": "Owner 23.9.2026: \"… pois ja näytetään koko url, ei ole koskaan liian pitkä, ei tarvitse leikata.\" The lane starts at the owner's left 120 and is wide enough for the whole URL; never truncated.",
      "size": 30
    },
    {
      "id": "copy.label",
      "text": "COPY",
      "role": "button",
      "className": "t-button",
      "x": 686,
      "y": 1100.61,
      "w": 112,
      "h": 40,
      "capCenterY": 1120.61,
      "maxW": 112,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "cta.label",
      "text": "INVITE FRIENDS",
      "role": "action",
      "className": "t-action on-gold",
      "x": 282,
      "y": 1309,
      "w": 482,
      "h": 70,
      "capCenterY": 1344,
      "maxW": 482,
      "align": "center",
      "color": "#17120a",
      "z": 46,
      "overflow": "visible",
      "layoutAdjustment": "Lane widened for fixed role action=56. The plate keeps the measured rim. People/chevron move outward inside the same plate."
    },
    {
      "id": "cta.caption",
      "text": "Need 1 more player to start",
      "role": "caption",
      "className": "t-caption",
      "x": 330,
      "y": 1440,
      "w": 351,
      "h": 33,
      "capCenterY": 1456.5,
      "maxW": 351,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 30
    },
    {
      "id": "howto.label",
      "text": "HOW TO PLAY",
      "role": "button",
      "className": "t-button",
      "x": 165,
      "y": 1534,
      "w": 234,
      "h": 40,
      "capCenterY": 1554,
      "maxW": 234,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 30
    },
    {
      "id": "settings.label",
      "text": "ROOM SETTINGS",
      "role": "button",
      "className": "t-button",
      "x": 574,
      "y": 1534,
      "w": 278,
      "h": 40,
      "capCenterY": 1554,
      "maxW": 278,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "layoutAdjustment": "Fixed button=32 needs a 265.5-unit ink width. Gear and text are spaced inside the unchanged button rim.",
      "size": 30
    }
  ],
  "hitTargets": [
    {
      "id": "back",
      "x": 16,
      "y": 9,
      "w": 120,
      "h": 120,
      "action": "back",
      "ariaLabel": "Back",
      "enabled": true
    },
    {
      "id": "sound",
      "x": 812,
      "y": 9,
      "w": 120,
      "h": 120,
      "action": "toggle-sound",
      "ariaLabel": "Sound on",
      "enabled": true
    },
    {
      "id": "seat1",
      "x": 101,
      "y": 447,
      "w": 240,
      "h": 296,
      "action": null,
      "enabled": false,
      "ariaLabel": "YOU, host",
      "note": "Hit box stays inside this seat cell; never creates a visible empty-seat pill.",
      "interactionRules": "seatInteractionRules"
    },
    {
      "id": "seat2",
      "x": 349,
      "y": 450,
      "w": 240,
      "h": 296,
      "action": "invite-friends",
      "enabled": true,
      "ariaLabel": "Open seat. Invite a friend.",
      "note": "Hit box stays inside this seat cell; never creates a visible empty-seat pill.",
      "interactionRules": "seatInteractionRules"
    },
    {
      "id": "seat3",
      "x": 596,
      "y": 451,
      "w": 240,
      "h": 296,
      "action": "invite-friends",
      "enabled": true,
      "ariaLabel": "Open seat. Invite a friend.",
      "note": "Hit box stays inside this seat cell; never creates a visible empty-seat pill.",
      "interactionRules": "seatInteractionRules"
    },
    {
      "id": "seat4",
      "x": 101,
      "y": 747,
      "w": 240,
      "h": 250,
      "action": "invite-friends",
      "enabled": true,
      "ariaLabel": "Open seat. Invite a friend.",
      "note": "Hit box stays inside this seat cell; never creates a visible empty-seat pill.",
      "interactionRules": "seatInteractionRules"
    },
    {
      "id": "seat5",
      "x": 347,
      "y": 747,
      "w": 240,
      "h": 250,
      "action": "invite-friends",
      "enabled": true,
      "ariaLabel": "Open seat. Invite a friend.",
      "note": "Hit box stays inside this seat cell; never creates a visible empty-seat pill.",
      "interactionRules": "seatInteractionRules"
    },
    {
      "id": "seat6",
      "x": 595,
      "y": 748,
      "w": 240,
      "h": 250,
      "action": "invite-friends",
      "enabled": true,
      "ariaLabel": "Open seat. Invite a friend.",
      "note": "Hit box stays inside this seat cell; never creates a visible empty-seat pill.",
      "interactionRules": "seatInteractionRules"
    }
  ],
  "seatVariants": {
    "1": {
      "open": {
        "elements": [
          {
            "id": "seat1.ring",
            "piece": "open.ring.png",
            "x": 61.535,
            "y": 471.026,
            "w": 319.545,
            "h": 253.178,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceCenter": {
              "x": 221,
              "y": 597
            },
            "referenceRadius": 108
          }
        ],
        "texts": [],
        "accessibleLabel": "Open seat. Invite a friend.",
        "action": "invite-friends",
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "occupied": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 117,
            "y": 493,
            "w": 208,
            "h": 208,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 1,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat1.ring",
            "piece": "seat.ring.png",
            "x": 74.615,
            "y": 472.897,
            "w": 293.333,
            "h": 248.205,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 221,
              "y": 597
            }
          },
          {
            "id": "seat1.pill",
            "piece": "pill.short.png",
            "x": 131,
            "y": 652,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat1.notready",
            "piece": "ready.badge.png",
            "x": 261,
            "y": 477,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24,
            "sourceFilter": "hue-rotate(170deg)"
          },
          {
            "id": "seat1.notready.icon",
            "piece": "icon.question.png",
            "x": 287,
            "y": 503,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg) hue-rotate(170deg)"
          }
        ],
        "texts": [
          {
            "id": "seat1.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 163,
            "y": 666,
            "w": 116,
            "h": 35,
            "capCenterY": 683.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, joined",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "host": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 119,
            "y": 495,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 1,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat1.ring",
            "piece": "host.ring.png",
            "x": 77.277,
            "y": 475.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 221,
              "y": 597
            }
          },
          {
            "id": "seat1.pill",
            "piece": "pill.short.png",
            "x": 131,
            "y": 650,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat1.status",
            "text": "HOST",
            "role": "status",
            "className": "t-status host",
            "x": 161,
            "y": 451,
            "w": 120,
            "h": 33,
            "capCenterY": 467.5,
            "maxW": 120,
            "align": "center",
            "color": "#ffd84a",
            "z": 46,
            "overflow": "visible",
            "size": 30
          },
          {
            "id": "seat1.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 163,
            "y": 664,
            "w": 116,
            "h": 35,
            "capCenterY": 681.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "ready": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 117,
            "y": 493,
            "w": 208,
            "h": 208,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 1,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat1.ring",
            "piece": "seat.ring.png",
            "x": 74.615,
            "y": 472.897,
            "w": 293.333,
            "h": 248.205,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 221,
              "y": 597
            }
          },
          {
            "id": "seat1.pill",
            "piece": "pill.short.png",
            "x": 131,
            "y": 652,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat1.ready",
            "piece": "ready.badge.png",
            "x": 261,
            "y": 477,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24
          },
          {
            "id": "seat1.ready.thumb",
            "piece": "icon.thumbs.png",
            "x": 287,
            "y": 502,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg)"
          }
        ],
        "texts": [
          {
            "id": "seat1.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 163,
            "y": 666,
            "w": 116,
            "h": 35,
            "capCenterY": 683.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, ready",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "offline": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 117,
            "y": 493,
            "w": 208,
            "h": 208,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 1,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat1.ring",
            "piece": "seat.ring.png",
            "x": 74.615,
            "y": 472.897,
            "w": 293.333,
            "h": 248.205,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 221,
              "y": 597
            }
          },
          {
            "id": "seat1.tag",
            "piece": "tag.host.png",
            "x": 130.241,
            "y": 680.569,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 141,
              "y": 692,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat1.pill",
            "piece": "pill.short.png",
            "x": 131,
            "y": 652,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat1.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 163,
            "y": 697.5,
            "w": 116,
            "h": 33,
            "capCenterY": 714,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat1.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 163,
            "y": 666,
            "w": 116,
            "h": 35,
            "capCenterY": 683.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "host_offline": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 119,
            "y": 495,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 1,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat1.ring",
            "piece": "host.ring.png",
            "x": 77.277,
            "y": 475.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 221,
              "y": 597
            }
          },
          {
            "id": "seat1.tag",
            "piece": "tag.host.png",
            "x": 130.241,
            "y": 445.069,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 141,
              "y": 456.5,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat1.pill",
            "piece": "pill.short.png",
            "x": 131,
            "y": 650,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat1.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 163,
            "y": 462,
            "w": 116,
            "h": 33,
            "capCenterY": 478.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat1.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 163,
            "y": 664,
            "w": 116,
            "h": 35,
            "capCenterY": 681.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      }
    },
    "2": {
      "open": {
        "elements": [
          {
            "id": "seat2.ring",
            "piece": "open.ring.png",
            "x": 319.871,
            "y": 482.191,
            "w": 298.834,
            "h": 236.768,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceCenter": {
              "x": 469,
              "y": 600
            },
            "referenceRadius": 101
          }
        ],
        "texts": [],
        "accessibleLabel": "Open seat. Invite a friend.",
        "action": "invite-friends",
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "occupied": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 372,
            "y": 503,
            "w": 194,
            "h": 194,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 2,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat2.ring",
            "piece": "seat.ring.png",
            "x": 331.931,
            "y": 483.795,
            "w": 274.667,
            "h": 232.411,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 469,
              "y": 600
            }
          },
          {
            "id": "seat2.pill",
            "piece": "pill.short.png",
            "x": 379,
            "y": 648,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat2.notready",
            "piece": "ready.badge.png",
            "x": 502,
            "y": 487,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24,
            "sourceFilter": "hue-rotate(170deg)"
          },
          {
            "id": "seat2.notready.icon",
            "piece": "icon.question.png",
            "x": 528,
            "y": 513,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg) hue-rotate(170deg)"
          }
        ],
        "texts": [
          {
            "id": "seat2.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 411,
            "y": 662,
            "w": 116,
            "h": 35,
            "capCenterY": 679.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, joined",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "host": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 367,
            "y": 498,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 2,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat2.ring",
            "piece": "host.ring.png",
            "x": 325.277,
            "y": 478.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 469,
              "y": 600
            }
          },
          {
            "id": "seat2.pill",
            "piece": "pill.short.png",
            "x": 379,
            "y": 653,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat2.status",
            "text": "HOST",
            "role": "status",
            "className": "t-status host",
            "x": 409,
            "y": 451,
            "w": 120,
            "h": 33,
            "capCenterY": 467.5,
            "maxW": 120,
            "align": "center",
            "color": "#ffd84a",
            "z": 46,
            "overflow": "visible",
            "size": 30
          },
          {
            "id": "seat2.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 411,
            "y": 667,
            "w": 116,
            "h": 35,
            "capCenterY": 684.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "ready": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 372,
            "y": 503,
            "w": 194,
            "h": 194,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 2,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat2.ring",
            "piece": "seat.ring.png",
            "x": 331.931,
            "y": 483.795,
            "w": 274.667,
            "h": 232.411,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 469,
              "y": 600
            }
          },
          {
            "id": "seat2.pill",
            "piece": "pill.short.png",
            "x": 379,
            "y": 648,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat2.ready",
            "piece": "ready.badge.png",
            "x": 502,
            "y": 487,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24
          },
          {
            "id": "seat2.ready.thumb",
            "piece": "icon.thumbs.png",
            "x": 528,
            "y": 512,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg)"
          }
        ],
        "texts": [
          {
            "id": "seat2.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 411,
            "y": 662,
            "w": 116,
            "h": 35,
            "capCenterY": 679.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, ready",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "offline": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 372,
            "y": 503,
            "w": 194,
            "h": 194,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 2,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat2.ring",
            "piece": "seat.ring.png",
            "x": 331.931,
            "y": 483.795,
            "w": 274.667,
            "h": 232.411,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 469,
              "y": 600
            }
          },
          {
            "id": "seat2.tag",
            "piece": "tag.host.png",
            "x": 378.241,
            "y": 683.569,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 389,
              "y": 695,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat2.pill",
            "piece": "pill.short.png",
            "x": 379,
            "y": 648,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat2.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 411,
            "y": 700.5,
            "w": 116,
            "h": 33,
            "capCenterY": 717,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat2.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 411,
            "y": 662,
            "w": 116,
            "h": 35,
            "capCenterY": 679.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "host_offline": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 367,
            "y": 498,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 2,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat2.ring",
            "piece": "host.ring.png",
            "x": 325.277,
            "y": 478.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 469,
              "y": 600
            }
          },
          {
            "id": "seat2.tag",
            "piece": "tag.host.png",
            "x": 378.241,
            "y": 448.069,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 389,
              "y": 459.5,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat2.pill",
            "piece": "pill.short.png",
            "x": 379,
            "y": 653,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat2.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 411,
            "y": 465,
            "w": 116,
            "h": 33,
            "capCenterY": 481.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat2.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 411,
            "y": 667,
            "w": 116,
            "h": 35,
            "capCenterY": 684.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      }
    },
    "3": {
      "open": {
        "elements": [
          {
            "id": "seat3.ring",
            "piece": "open.ring.png",
            "x": 566.871,
            "y": 483.191,
            "w": 298.834,
            "h": 236.768,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceCenter": {
              "x": 716,
              "y": 601
            },
            "referenceRadius": 101
          }
        ],
        "texts": [],
        "accessibleLabel": "Open seat. Invite a friend.",
        "action": "invite-friends",
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "occupied": {
        "elements": [
          {
            "id": "seat3.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 619,
            "y": 504,
            "w": 194,
            "h": 194,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 3,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat3.ring",
            "piece": "seat.ring.png",
            "x": 578.931,
            "y": 484.795,
            "w": 274.667,
            "h": 232.411,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 716,
              "y": 601
            }
          },
          {
            "id": "seat3.pill",
            "piece": "pill.short.png",
            "x": 626,
            "y": 649,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat3.notready",
            "piece": "ready.badge.png",
            "x": 749,
            "y": 488,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24,
            "sourceFilter": "hue-rotate(170deg)"
          },
          {
            "id": "seat3.notready.icon",
            "piece": "icon.question.png",
            "x": 775,
            "y": 514,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg) hue-rotate(170deg)"
          }
        ],
        "texts": [
          {
            "id": "seat3.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 658,
            "y": 663,
            "w": 116,
            "h": 35,
            "capCenterY": 680.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 3,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, joined",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "host": {
        "elements": [
          {
            "id": "seat3.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 614,
            "y": 499,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 3,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat3.ring",
            "piece": "host.ring.png",
            "x": 572.277,
            "y": 479.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 716,
              "y": 601
            }
          },
          {
            "id": "seat3.pill",
            "piece": "pill.short.png",
            "x": 626,
            "y": 654,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat3.status",
            "text": "HOST",
            "role": "status",
            "className": "t-status host",
            "x": 656,
            "y": 451,
            "w": 120,
            "h": 33,
            "capCenterY": 467.5,
            "maxW": 120,
            "align": "center",
            "color": "#ffd84a",
            "z": 46,
            "overflow": "visible",
            "size": 30
          },
          {
            "id": "seat3.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 658,
            "y": 668,
            "w": 116,
            "h": 35,
            "capCenterY": 685.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 3,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "ready": {
        "elements": [
          {
            "id": "seat3.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 619,
            "y": 504,
            "w": 194,
            "h": 194,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 3,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat3.ring",
            "piece": "seat.ring.png",
            "x": 578.931,
            "y": 484.795,
            "w": 274.667,
            "h": 232.411,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 716,
              "y": 601
            }
          },
          {
            "id": "seat3.pill",
            "piece": "pill.short.png",
            "x": 626,
            "y": 649,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat3.ready",
            "piece": "ready.badge.png",
            "x": 749,
            "y": 488,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24
          },
          {
            "id": "seat3.ready.thumb",
            "piece": "icon.thumbs.png",
            "x": 775,
            "y": 513,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg)"
          }
        ],
        "texts": [
          {
            "id": "seat3.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 658,
            "y": 663,
            "w": 116,
            "h": 35,
            "capCenterY": 680.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 3,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, ready",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "offline": {
        "elements": [
          {
            "id": "seat3.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 619,
            "y": 504,
            "w": 194,
            "h": 194,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 3,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat3.ring",
            "piece": "seat.ring.png",
            "x": 578.931,
            "y": 484.795,
            "w": 274.667,
            "h": 232.411,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 716,
              "y": 601
            }
          },
          {
            "id": "seat3.tag",
            "piece": "tag.host.png",
            "x": 625.241,
            "y": 684.569,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 636,
              "y": 696,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat3.pill",
            "piece": "pill.short.png",
            "x": 626,
            "y": 649,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat3.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 658,
            "y": 701.5,
            "w": 116,
            "h": 33,
            "capCenterY": 718,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat3.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 658,
            "y": 663,
            "w": 116,
            "h": 35,
            "capCenterY": 680.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 3,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "host_offline": {
        "elements": [
          {
            "id": "seat3.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 614,
            "y": 499,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 3,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat3.ring",
            "piece": "host.ring.png",
            "x": 572.277,
            "y": 479.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 716,
              "y": 601
            }
          },
          {
            "id": "seat3.tag",
            "piece": "tag.host.png",
            "x": 625.241,
            "y": 449.069,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 636,
              "y": 460.5,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat3.pill",
            "piece": "pill.short.png",
            "x": 626,
            "y": 654,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat3.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 658,
            "y": 466,
            "w": 116,
            "h": 33,
            "capCenterY": 482.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat3.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 658,
            "y": 668,
            "w": 116,
            "h": 35,
            "capCenterY": 685.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 3,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      }
    },
    "4": {
      "open": {
        "elements": [
          {
            "id": "seat4.ring",
            "piece": "open.ring.png",
            "x": 70.394,
            "y": 730.024,
            "w": 301.792,
            "h": 239.112,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceCenter": {
              "x": 221,
              "y": 849
            },
            "referenceRadius": 102
          }
        ],
        "texts": [],
        "accessibleLabel": "Open seat. Invite a friend.",
        "action": "invite-friends",
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "occupied": {
        "elements": [
          {
            "id": "seat4.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 123,
            "y": 751,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 4,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat4.ring",
            "piece": "seat.ring.png",
            "x": 82.6,
            "y": 731.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 221,
              "y": 849
            }
          },
          {
            "id": "seat4.pill",
            "piece": "pill.short.png",
            "x": 131,
            "y": 898,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat4.notready",
            "piece": "ready.badge.png",
            "x": 255,
            "y": 735,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24,
            "sourceFilter": "hue-rotate(170deg)"
          },
          {
            "id": "seat4.notready.icon",
            "piece": "icon.question.png",
            "x": 281,
            "y": 761,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg) hue-rotate(170deg)"
          }
        ],
        "texts": [
          {
            "id": "seat4.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 163,
            "y": 912,
            "w": 116,
            "h": 35,
            "capCenterY": 929.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 4,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, joined",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "host": {
        "elements": [
          {
            "id": "seat4.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 119,
            "y": 747,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 4,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat4.ring",
            "piece": "host.ring.png",
            "x": 77.277,
            "y": 727.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 221,
              "y": 849
            }
          },
          {
            "id": "seat4.pill",
            "piece": "pill.short.png",
            "x": 131,
            "y": 902,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat4.status",
            "text": "HOST",
            "role": "status",
            "className": "t-status host",
            "x": 161,
            "y": 703,
            "w": 120,
            "h": 33,
            "capCenterY": 719.5,
            "maxW": 120,
            "align": "center",
            "color": "#ffd84a",
            "z": 46,
            "overflow": "visible",
            "size": 30
          },
          {
            "id": "seat4.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 163,
            "y": 916,
            "w": 116,
            "h": 35,
            "capCenterY": 933.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 4,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "ready": {
        "elements": [
          {
            "id": "seat4.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 123,
            "y": 751,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 4,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat4.ring",
            "piece": "seat.ring.png",
            "x": 82.6,
            "y": 731.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 221,
              "y": 849
            }
          },
          {
            "id": "seat4.pill",
            "piece": "pill.short.png",
            "x": 131,
            "y": 898,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat4.ready",
            "piece": "ready.badge.png",
            "x": 255,
            "y": 735,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24
          },
          {
            "id": "seat4.ready.thumb",
            "piece": "icon.thumbs.png",
            "x": 281,
            "y": 760,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg)"
          }
        ],
        "texts": [
          {
            "id": "seat4.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 163,
            "y": 912,
            "w": 116,
            "h": 35,
            "capCenterY": 929.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 4,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, ready",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "offline": {
        "elements": [
          {
            "id": "seat4.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 123,
            "y": 751,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 4,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat4.ring",
            "piece": "seat.ring.png",
            "x": 82.6,
            "y": 731.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 221,
              "y": 849
            }
          },
          {
            "id": "seat4.tag",
            "piece": "tag.host.png",
            "x": 130.241,
            "y": 932.569,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 141,
              "y": 944,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat4.pill",
            "piece": "pill.short.png",
            "x": 131,
            "y": 898,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat4.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 163,
            "y": 949.5,
            "w": 116,
            "h": 33,
            "capCenterY": 966,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat4.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 163,
            "y": 912,
            "w": 116,
            "h": 35,
            "capCenterY": 929.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 4,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "host_offline": {
        "elements": [
          {
            "id": "seat4.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 119,
            "y": 747,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 4,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat4.ring",
            "piece": "host.ring.png",
            "x": 77.277,
            "y": 727.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 221,
              "y": 849
            }
          },
          {
            "id": "seat4.tag",
            "piece": "tag.host.png",
            "x": 195.241,
            "y": 749.498,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 206,
              "y": 760.929,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat4.pill",
            "piece": "pill.short.png",
            "x": 131,
            "y": 902,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat4.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 228,
            "y": 766.429,
            "w": 116,
            "h": 33,
            "capCenterY": 782.929,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat4.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 163,
            "y": 916,
            "w": 116,
            "h": 35,
            "capCenterY": 933.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 4,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      }
    },
    "5": {
      "open": {
        "elements": [
          {
            "id": "seat5.ring",
            "piece": "open.ring.png",
            "x": 316.394,
            "y": 730.024,
            "w": 301.792,
            "h": 239.112,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceCenter": {
              "x": 467,
              "y": 849
            },
            "referenceRadius": 102
          }
        ],
        "texts": [],
        "accessibleLabel": "Open seat. Invite a friend.",
        "action": "invite-friends",
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "occupied": {
        "elements": [
          {
            "id": "seat5.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 369,
            "y": 751,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 5,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat5.ring",
            "piece": "seat.ring.png",
            "x": 328.6,
            "y": 731.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 467,
              "y": 849
            }
          },
          {
            "id": "seat5.pill",
            "piece": "pill.short.png",
            "x": 377,
            "y": 898,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat5.notready",
            "piece": "ready.badge.png",
            "x": 501,
            "y": 735,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24,
            "sourceFilter": "hue-rotate(170deg)"
          },
          {
            "id": "seat5.notready.icon",
            "piece": "icon.question.png",
            "x": 527,
            "y": 761,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg) hue-rotate(170deg)"
          }
        ],
        "texts": [
          {
            "id": "seat5.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 409,
            "y": 912,
            "w": 116,
            "h": 35,
            "capCenterY": 929.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 5,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, joined",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "host": {
        "elements": [
          {
            "id": "seat5.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 365,
            "y": 747,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 5,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat5.ring",
            "piece": "host.ring.png",
            "x": 323.277,
            "y": 727.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 467,
              "y": 849
            }
          },
          {
            "id": "seat5.pill",
            "piece": "pill.short.png",
            "x": 377,
            "y": 902,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat5.status",
            "text": "HOST",
            "role": "status",
            "className": "t-status host",
            "x": 407,
            "y": 703,
            "w": 120,
            "h": 33,
            "capCenterY": 719.5,
            "maxW": 120,
            "align": "center",
            "color": "#ffd84a",
            "z": 46,
            "overflow": "visible",
            "size": 30
          },
          {
            "id": "seat5.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 409,
            "y": 916,
            "w": 116,
            "h": 35,
            "capCenterY": 933.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 5,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "ready": {
        "elements": [
          {
            "id": "seat5.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 369,
            "y": 751,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 5,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat5.ring",
            "piece": "seat.ring.png",
            "x": 328.6,
            "y": 731.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 467,
              "y": 849
            }
          },
          {
            "id": "seat5.pill",
            "piece": "pill.short.png",
            "x": 377,
            "y": 898,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat5.ready",
            "piece": "ready.badge.png",
            "x": 501,
            "y": 735,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24
          },
          {
            "id": "seat5.ready.thumb",
            "piece": "icon.thumbs.png",
            "x": 527,
            "y": 760,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg)"
          }
        ],
        "texts": [
          {
            "id": "seat5.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 409,
            "y": 912,
            "w": 116,
            "h": 35,
            "capCenterY": 929.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 5,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, ready",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "offline": {
        "elements": [
          {
            "id": "seat5.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 369,
            "y": 751,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 5,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat5.ring",
            "piece": "seat.ring.png",
            "x": 328.6,
            "y": 731.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 467,
              "y": 849
            }
          },
          {
            "id": "seat5.tag",
            "piece": "tag.host.png",
            "x": 376.241,
            "y": 932.569,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 387,
              "y": 944,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat5.pill",
            "piece": "pill.short.png",
            "x": 377,
            "y": 898,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat5.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 409,
            "y": 949.5,
            "w": 116,
            "h": 33,
            "capCenterY": 966,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat5.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 409,
            "y": 912,
            "w": 116,
            "h": 35,
            "capCenterY": 929.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 5,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "host_offline": {
        "elements": [
          {
            "id": "seat5.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 365,
            "y": 747,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 5,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat5.ring",
            "piece": "host.ring.png",
            "x": 323.277,
            "y": 727.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 467,
              "y": 849
            }
          },
          {
            "id": "seat5.tag",
            "piece": "tag.host.png",
            "x": 441.241,
            "y": 749.498,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 452,
              "y": 760.929,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat5.pill",
            "piece": "pill.short.png",
            "x": 377,
            "y": 902,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat5.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 474,
            "y": 766.429,
            "w": 116,
            "h": 33,
            "capCenterY": 782.929,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat5.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 409,
            "y": 916,
            "w": 116,
            "h": 35,
            "capCenterY": 933.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 5,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      }
    },
    "6": {
      "open": {
        "elements": [
          {
            "id": "seat6.ring",
            "piece": "open.ring.png",
            "x": 564.394,
            "y": 731.024,
            "w": 301.792,
            "h": 239.112,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceCenter": {
              "x": 715,
              "y": 850
            },
            "referenceRadius": 102
          }
        ],
        "texts": [],
        "accessibleLabel": "Open seat. Invite a friend.",
        "action": "invite-friends",
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "occupied": {
        "elements": [
          {
            "id": "seat6.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 617,
            "y": 752,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 6,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat6.ring",
            "piece": "seat.ring.png",
            "x": 576.6,
            "y": 732.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 715,
              "y": 850
            }
          },
          {
            "id": "seat6.pill",
            "piece": "pill.short.png",
            "x": 625,
            "y": 899,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat6.notready",
            "piece": "ready.badge.png",
            "x": 749,
            "y": 736,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24,
            "sourceFilter": "hue-rotate(170deg)"
          },
          {
            "id": "seat6.notready.icon",
            "piece": "icon.question.png",
            "x": 775,
            "y": 762,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg) hue-rotate(170deg)"
          }
        ],
        "texts": [
          {
            "id": "seat6.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 657,
            "y": 913,
            "w": 116,
            "h": 35,
            "capCenterY": 930.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 6,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, joined",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules"
      },
      "host": {
        "elements": [
          {
            "id": "seat6.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 613,
            "y": 748,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 6,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat6.ring",
            "piece": "host.ring.png",
            "x": 571.277,
            "y": 728.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 715,
              "y": 850
            }
          },
          {
            "id": "seat6.pill",
            "piece": "pill.short.png",
            "x": 625,
            "y": 903,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat6.status",
            "text": "HOST",
            "role": "status",
            "className": "t-status host",
            "x": 655,
            "y": 703,
            "w": 120,
            "h": 33,
            "capCenterY": 719.5,
            "maxW": 120,
            "align": "center",
            "color": "#ffd84a",
            "z": 46,
            "overflow": "visible",
            "size": 30
          },
          {
            "id": "seat6.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 657,
            "y": 917,
            "w": 116,
            "h": 35,
            "capCenterY": 934.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 6,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "ready": {
        "elements": [
          {
            "id": "seat6.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 617,
            "y": 752,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 6,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat6.ring",
            "piece": "seat.ring.png",
            "x": 576.6,
            "y": 732.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceCenter": {
              "x": 715,
              "y": 850
            }
          },
          {
            "id": "seat6.pill",
            "piece": "pill.short.png",
            "x": 625,
            "y": 899,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          },
          {
            "id": "seat6.ready",
            "piece": "ready.badge.png",
            "x": 749,
            "y": 736,
            "w": 80,
            "h": 80,
            "render": "image",
            "tint": "none",
            "z": 24
          },
          {
            "id": "seat6.ready.thumb",
            "piece": "icon.thumbs.png",
            "x": 775,
            "y": 761,
            "w": 28,
            "h": 28,
            "render": "image",
            "tint": "none",
            "z": 25,
            "sourceFilter": "invert(1) brightness(1) saturate(3) hue-rotate(90deg)"
          }
        ],
        "texts": [
          {
            "id": "seat6.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 657,
            "y": 913,
            "w": 116,
            "h": 35,
            "capCenterY": 930.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 6,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, ready",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "offline": {
        "elements": [
          {
            "id": "seat6.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 617,
            "y": 752,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 6,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat6.ring",
            "piece": "seat.ring.png",
            "x": 576.6,
            "y": 732.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 715,
              "y": 850
            }
          },
          {
            "id": "seat6.tag",
            "piece": "tag.host.png",
            "x": 624.241,
            "y": 933.569,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 635,
              "y": 945,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat6.pill",
            "piece": "pill.short.png",
            "x": 625,
            "y": 899,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat6.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 657,
            "y": 950.5,
            "w": 116,
            "h": 33,
            "capCenterY": 967,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat6.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 657,
            "y": 913,
            "w": 116,
            "h": 35,
            "capCenterY": 930.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 6,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Player, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      },
      "host_offline": {
        "elements": [
          {
            "id": "seat6.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 613,
            "y": 748,
            "w": 204,
            "h": 204,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 6,
              "fallbackAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat6.ring",
            "piece": "host.ring.png",
            "x": 571.277,
            "y": 728.154,
            "w": 288,
            "h": 243.692,
            "render": "image",
            "tint": "none",
            "z": 20,
            "opacity": 0.5,
            "referenceCenter": {
              "x": 715,
              "y": 850
            }
          },
          {
            "id": "seat6.tag",
            "piece": "tag.host.png",
            "x": 689.241,
            "y": 750.498,
            "w": 181.517,
            "h": 61.862,
            "render": "3-slice",
            "tint": "cyan",
            "z": 22,
            "slicePx": {
              "left": 50,
              "right": 50,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "referenceTubeBox": {
              "x": 700,
              "y": 761.929,
              "w": 160,
              "h": 39
            },
            "opacity": 0.62
          },
          {
            "id": "seat6.pill",
            "piece": "pill.short.png",
            "x": 625,
            "y": 903,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 23,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat6.status",
            "text": "OFFLINE",
            "role": "status",
            "className": "t-status offline",
            "x": 722,
            "y": 767.429,
            "w": 116,
            "h": 33,
            "capCenterY": 783.929,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "clip"
          },
          {
            "id": "seat6.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 657,
            "y": 917,
            "w": 116,
            "h": 35,
            "capCenterY": 934.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 6,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; never shrink glyphs"
            }
          }
        ],
        "accessibleLabel": "Host, offline",
        "action": "contextual-player-action",
        "hasNamePill": true,
        "hasStatusTag": true,
        "interactionRules": "seatInteractionRules"
      }
    }
  },
  "states": {
    "host_waiting": {
      "elementOverrides": {},
      "textOverrides": {},
      "hitOverrides": {},
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "isHost && inviteActive && joinedCount < 2",
      "values": {
        "isHost": true,
        "joinedCount": 1,
        "capacity": 6,
        "openSeatCount": 5,
        "remaining": "05:36"
      },
      "seats": {
        "1": {
          "variant": "host",
          "name": "YOU",
          "avatar": "snw-cast-0056",
          "isSelf": true
        },
        "2": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "3": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "4": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "5": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "6": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        }
      },
      "cta": {
        "label": "INVITE FRIENDS",
        "role": "action",
        "action": "invite-friends",
        "disabled": false,
        "icons": [
          "cta.people",
          "cta.chevron"
        ]
      }
    },
    "host_ready": {
      "elementOverrides": {},
      "textOverrides": {
        "cta.label": {
          "x": 214,
          "y": 1220,
          "w": 512,
          "h": 70,
          "maxW": 512,
          "capCenterY": 1255,
          "text": "START MATCH"
        },
        "cta.caption": {
          "text": "Ready when you are",
          "x": 200,
          "w": 540,
          "maxW": 540
        }
      },
      "hitOverrides": {
        "cta": {
          "action": "start-match",
          "ariaLabel": "Start match",
          "enabled": true
        }
      },
      "hiddenElements": [
        "cta.people",
        "cta.chevron",
        "cta.caption.icon"
      ],
      "hiddenTexts": [],
      "when": "isHost && inviteActive && joinedCount >= 2",
      "values": {
        "isHost": true,
        "joinedCount": 2,
        "capacity": 6,
        "openSeatCount": 4,
        "remaining": "05:36"
      },
      "seats": {
        "1": {
          "variant": "host",
          "name": "YOU",
          "avatar": "snw-cast-0056",
          "isSelf": true
        },
        "2": {
          "variant": "ready",
          "name": "Ada",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "3": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "4": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "5": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "6": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        }
      },
      "cta": {
        "label": "START MATCH",
        "role": "action",
        "action": "start-match",
        "disabled": false,
        "icons": []
      }
    },
    "guest_joined": {
      "elementOverrides": {
        "settings.icon": {
          "piece": "icon.door.png",
          "x": 507,
          "y": 1411,
          "w": 56,
          "h": 56
        }
      },
      "textOverrides": {
        "cta.label": {
          "x": 214,
          "y": 1220,
          "w": 512,
          "h": 70,
          "maxW": 512,
          "capCenterY": 1255,
          "text": "I'M READY"
        },
        "cta.caption": {
          "text": "Waiting for the host to start",
          "x": 200,
          "w": 540,
          "maxW": 540
        },
        "settings.label": {
          "text": "LEAVE ROOM"
        }
      },
      "hitOverrides": {
        "cta": {
          "action": "mark-ready",
          "ariaLabel": "I'm ready",
          "enabled": true
        },
        "settings": {
          "action": "leave-room",
          "ariaLabel": "Leave room"
        }
      },
      "hiddenElements": [
        "cta.people",
        "cta.chevron",
        "cta.caption.icon"
      ],
      "hiddenTexts": [],
      "when": "!isHost && inviteActive && !selfReady",
      "values": {
        "isHost": false,
        "joinedCount": 2,
        "capacity": 6,
        "openSeatCount": 4,
        "remaining": "05:36"
      },
      "seats": {
        "1": {
          "variant": "host",
          "name": "Sami",
          "avatar": "snw-cast-0056",
          "isSelf": false
        },
        "2": {
          "variant": "occupied",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": true
        },
        "3": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "4": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "5": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "6": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        }
      },
      "cta": {
        "label": "I'M READY",
        "role": "action",
        "action": "mark-ready",
        "disabled": false,
        "icons": []
      }
    },
    "guest_ready": {
      "elementOverrides": {
        "settings.icon": {
          "piece": "icon.door.png",
          "x": 507,
          "y": 1411,
          "w": 56,
          "h": 56
        },
        "cta.plate": {
          "brightness": 0.58,
          "opacity": 0.95
        }
      },
      "textOverrides": {
        "cta.label": {
          "x": 214,
          "y": 1220,
          "w": 512,
          "h": 70,
          "maxW": 512,
          "capCenterY": 1255,
          "text": "READY",
          "color": "#2a2417",
          "className": "t-action on-gold off"
        },
        "cta.caption": {
          "text": "Waiting for the host to start",
          "x": 200,
          "w": 540,
          "maxW": 540
        },
        "settings.label": {
          "text": "LEAVE ROOM"
        }
      },
      "hitOverrides": {
        "cta": {
          "action": null,
          "ariaLabel": "Ready",
          "enabled": false
        },
        "settings": {
          "action": "leave-room",
          "ariaLabel": "Leave room"
        }
      },
      "hiddenElements": [
        "cta.people",
        "cta.chevron",
        "cta.caption.icon"
      ],
      "hiddenTexts": [],
      "when": "!isHost && inviteActive && selfReady",
      "values": {
        "isHost": false,
        "joinedCount": 2,
        "capacity": 6,
        "openSeatCount": 4,
        "remaining": "05:36"
      },
      "seats": {
        "1": {
          "variant": "host",
          "name": "Sami",
          "avatar": "snw-cast-0056",
          "isSelf": false
        },
        "2": {
          "variant": "ready",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": true
        },
        "3": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "4": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "5": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "6": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        }
      },
      "cta": {
        "label": "READY",
        "role": "action",
        "action": null,
        "disabled": true,
        "icons": []
      }
    },
    "expired": {
      "elementOverrides": {
        "cta.plate": {
          "brightness": 0.58,
          "opacity": 0.95
        },
        "copy.button": {
          "brightness": 0.58,
          "opacity": 0.7
        },
        "copy.icon": {
          "opacity": 0.55
        },
        "status.clock": {
          "x": 369,
          "y": 368,
          "w": 32,
          "h": 32
        }
      },
      "textOverrides": {
        "copy.label": {
          "color": "#8f9ac4"
        },
        "status.heading": {
          "text": "INVITE EXPIRED"
        },
        "status.timer": {
          "text": "Invites closed",
          "x": 408,
          "w": 166,
          "maxW": 166,
          "binding": {
            "kind": "literal",
            "value": "Invites closed"
          }
        },
        "cta.label": {
          "x": 214,
          "y": 1220,
          "w": 512,
          "h": 70,
          "maxW": 512,
          "capCenterY": 1255,
          "text": "INVITE EXPIRED",
          "color": "#2a2417",
          "className": "t-action on-gold off"
        },
        "cta.caption": {
          "text": "Invites are closed",
          "x": 200,
          "w": 540,
          "maxW": 540
        }
      },
      "hitOverrides": {
        "cta": {
          "action": null,
          "ariaLabel": "Invite expired",
          "enabled": false
        },
        "copy": {
          "action": null,
          "enabled": false,
          "ariaLabel": "Invite expired"
        }
      },
      "hiddenElements": [
        "cta.people",
        "cta.chevron",
        "cta.caption.icon"
      ],
      "hiddenTexts": [],
      "when": "!inviteActive; precedence over host/guest states",
      "values": {
        "isHost": true,
        "joinedCount": 1,
        "capacity": 6,
        "openSeatCount": 5,
        "remaining": "00:00"
      },
      "seats": {
        "1": {
          "variant": "host",
          "name": "YOU",
          "avatar": "snw-cast-0056",
          "isSelf": true
        },
        "2": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "3": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "4": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "5": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        },
        "6": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001",
          "isSelf": false
        }
      },
      "roleOverrides": {
        "guest": {
          "when": "!isHost",
          "textOverrides": {
            "settings.label": {
              "text": "LEAVE ROOM"
            }
          },
          "elementOverrides": {
            "settings.icon": {
              "piece": "icon.door.png",
              "x": 507,
              "y": 1411,
              "w": 56,
              "h": 56
            }
          },
          "hitOverrides": {
            "settings": {
              "action": "leave-room",
              "ariaLabel": "Leave room"
            }
          }
        },
        "host": {
          "when": "isHost",
          "textOverrides": {
            "settings.label": {
              "text": "ROOM SETTINGS"
            }
          },
          "elementOverrides": {
            "settings.icon": {
              "piece": "icon.gear.png",
              "x": 507,
              "y": 1411,
              "w": 56,
              "h": 56
            }
          },
          "hitOverrides": {
            "settings": {
              "action": "room-settings",
              "ariaLabel": "Room settings"
            }
          }
        }
      },
      "cta": {
        "label": "INVITE EXPIRED",
        "role": "action",
        "action": null,
        "disabled": true,
        "icons": []
      },
      "openSeatPolicy": {
        "interactionRules": "seatInteractionRules",
        "enabled": false,
        "when": "variant == open; does not disable other-player actions"
      }
    }
  },
  "examples": [
    {
      "id": "host_waiting",
      "state": "host_waiting",
      "theme": "friends",
      "code": "S4PKPU",
      "url": "play.saynoway.com/r/S4PKPU"
    },
    {
      "id": "host_ready",
      "state": "host_ready",
      "theme": "friends",
      "code": "S4PKPU",
      "url": "play.saynoway.com/r/S4PKPU"
    },
    {
      "id": "guest_joined",
      "state": "guest_joined",
      "theme": "friends",
      "code": "S4PKPU",
      "url": "play.saynoway.com/r/S4PKPU"
    },
    {
      "id": "guest_ready",
      "state": "guest_ready",
      "theme": "friends",
      "code": "S4PKPU",
      "url": "play.saynoway.com/r/S4PKPU"
    },
    {
      "id": "expired",
      "state": "expired",
      "theme": "friends",
      "code": "S4PKPU",
      "url": "play.saynoway.com/r/S4PKPU"
    }
  ],
  "measurements": {
    "reference": "friends-lobby-mockup.png",
    "stage": {
      "w": 941,
      "h": 1672
    },
    "method": "Direct pixel sampling: maximum warm-neon straight-ridge response in recorded strips; circular neon response across 180 angle samples; glyph-core threshold in recorded ROIs. Measurements exclude diffuse glow. The dim YOU/HOST ridges are measured separately at their low-luminance foreground tube, excluding the bright avatar-ring behind them.",
    "boards": {
      "status": {
        "x0": 170,
        "x1": 770,
        "y0": 259,
        "y1": 413
      },
      "code": {
        "x0": 66,
        "x1": 874,
        "y0": 964,
        "y1": 1144
      },
      "cta": {
        "x0": 60,
        "x1": 880,
        "y0": 1195,
        "y1": 1316
      },
      "howto": {
        "x0": 58,
        "x1": 456,
        "y0": 1400,
        "y1": 1478
      },
      "settings": {
        "x0": 485,
        "x1": 884,
        "y0": 1400,
        "y1": 1478
      },
      "copy": {
        "x0": 617,
        "x1": 816,
        "y0": 1019,
        "y1": 1099
      },
      "you": {
        "x0": 157,
        "x1": 285,
        "y0": 636,
        "y1": 670
      },
      "host": {
        "x0": 141,
        "x1": 301,
        "y0": 662,
        "y1": 701
      }
    },
    "texts": [
      {
        "id": "status.heading",
        "roi": [
          218,
          280,
          515,
          34
        ],
        "threshold": "gold",
        "ink": {
          "x": 229,
          "y": 285,
          "w": 482,
          "h": 23,
          "centerX": 469.5,
          "centerY": 296,
          "pixels": 4317
        }
      },
      {
        "id": "status.body",
        "roi": [
          269,
          325,
          408,
          34
        ],
        "threshold": "mixed",
        "ink": {
          "x": 279,
          "y": 330,
          "w": 384,
          "h": 27,
          "centerX": 470.5,
          "centerY": 343,
          "pixels": 2221
        }
      },
      {
        "id": "status.timer",
        "roi": [
          358,
          369,
          267,
          31
        ],
        "threshold": "white",
        "ink": {
          "x": 367,
          "y": 375,
          "w": 239,
          "h": 22,
          "centerX": 486,
          "centerY": 385.5,
          "pixels": 910
        }
      },
      {
        "id": "seat1.name",
        "roi": [
          181,
          641,
          81,
          26
        ],
        "threshold": "white",
        "ink": {
          "x": 199,
          "y": 645,
          "w": 45,
          "h": 16,
          "centerX": 221,
          "centerY": 652.5,
          "pixels": 286
        }
      },
      {
        "id": "seat1.status",
        "roi": [
          207,
          675,
          65,
          24
        ],
        "threshold": "gold",
        "ink": {
          "x": 209,
          "y": 678,
          "w": 52,
          "h": 13,
          "centerX": 234.5,
          "centerY": 684,
          "pixels": 259
        }
      },
      {
        "id": "code.heading",
        "roi": [
          251,
          990,
          183,
          29
        ],
        "threshold": "white",
        "ink": {
          "x": 263,
          "y": 995,
          "w": 154,
          "h": 15,
          "centerX": 339.5,
          "centerY": 1002,
          "pixels": 631
        }
      },
      {
        "id": "code.value",
        "roi": [
          171,
          1024,
          342,
          68
        ],
        "threshold": "gold",
        "ink": {
          "x": 182,
          "y": 1030,
          "w": 324,
          "h": 57,
          "centerX": 343.5,
          "centerY": 1058,
          "pixels": 9084
        }
      },
      {
        "id": "code.url",
        "roi": [
          181,
          1097,
          362,
          31
        ],
        "threshold": "white",
        "ink": {
          "x": 192,
          "y": 1101,
          "w": 302,
          "h": 20,
          "centerX": 342.5,
          "centerY": 1110.5,
          "pixels": 990
        }
      },
      {
        "id": "copy.label",
        "roi": [
          694,
          1045,
          89,
          34
        ],
        "threshold": "white",
        "ink": {
          "x": 702,
          "y": 1052,
          "w": 74,
          "h": 19,
          "centerX": 738.5,
          "centerY": 1061,
          "pixels": 508
        }
      },
      {
        "id": "cta.label",
        "roi": [
          314,
          1226,
          381,
          58
        ],
        "threshold": "dark",
        "ink": {
          "x": 326,
          "y": 1239,
          "w": 353,
          "h": 33,
          "centerX": 502,
          "centerY": 1255,
          "pixels": 5850
        }
      },
      {
        "id": "cta.caption",
        "roi": [
          326,
          1337,
          393,
          37
        ],
        "threshold": "white",
        "ink": {
          "x": 338,
          "y": 1346,
          "w": 321,
          "h": 23,
          "centerX": 498,
          "centerY": 1357,
          "pixels": 1025
        }
      },
      {
        "id": "howto.label",
        "roi": [
          202,
          1422,
          204,
          40
        ],
        "threshold": "white",
        "ink": {
          "x": 223,
          "y": 1432,
          "w": 175,
          "h": 18,
          "centerX": 310,
          "centerY": 1440.5,
          "pixels": 1045
        }
      },
      {
        "id": "settings.label",
        "roi": [
          595,
          1422,
          237,
          40
        ],
        "threshold": "white",
        "ink": {
          "x": 629,
          "y": 1432,
          "w": 202,
          "h": 18,
          "centerX": 729.5,
          "centerY": 1440.5,
          "pixels": 1407
        }
      }
    ],
    "seats": [
      {
        "id": "seat1",
        "cx": 221,
        "cy": 567,
        "r": 108,
        "score": 28796
      },
      {
        "id": "seat2",
        "cx": 469,
        "cy": 570,
        "r": 101,
        "score": 24454
      },
      {
        "id": "seat3",
        "cx": 716,
        "cy": 571,
        "r": 101,
        "score": 24379
      },
      {
        "id": "seat4",
        "cx": 221,
        "cy": 819,
        "r": 102,
        "score": 24259
      },
      {
        "id": "seat5",
        "cx": 467,
        "cy": 819,
        "r": 102,
        "score": 23622
      },
      {
        "id": "seat6",
        "cx": 715,
        "cy": 820,
        "r": 102,
        "score": 24382
      }
    ],
    "iconInk": [
      {
        "id": "status.clock",
        "roi": [
          319,
          365,
          42,
          35
        ],
        "threshold": "white",
        "ink": {
          "x": 328,
          "y": 371,
          "w": 25,
          "h": 25
        }
      },
      {
        "id": "host.tag.crown",
        "roi": [
          175,
          674,
          31,
          25
        ],
        "threshold": "gold",
        "ink": {
          "x": 179,
          "y": 676,
          "w": 20,
          "h": 16
        }
      },
      {
        "id": "copy.icon",
        "roi": [
          638,
          1033,
          51,
          53
        ],
        "threshold": "gold",
        "ink": {
          "x": 647,
          "y": 1041,
          "w": 33,
          "h": 38
        }
      },
      {
        "id": "cta.people",
        "roi": [
          189,
          1221,
          96,
          61
        ],
        "threshold": "dark",
        "ink": {
          "x": 199,
          "y": 1227,
          "w": 78,
          "h": 51
        }
      },
      {
        "id": "cta.chevron",
        "roi": [
          722,
          1231,
          29,
          48
        ],
        "threshold": "dark",
        "ink": {
          "x": 729,
          "y": 1239,
          "w": 18,
          "h": 32
        }
      },
      {
        "id": "howto.icon",
        "roi": [
          116,
          1410,
          66,
          54
        ],
        "threshold": "white",
        "ink": {
          "x": 127,
          "y": 1420,
          "w": 48,
          "h": 41
        }
      },
      {
        "id": "settings.icon",
        "roi": [
          533,
          1408,
          62,
          64
        ],
        "threshold": "white",
        "ink": {
          "x": 543,
          "y": 1417,
          "w": 45,
          "h": 46
        }
      }
    ]
  },
  "notes": [
    "The mockup contains painted words; every functional word here is a text lane. Logos and the two decorative upper stickers remain existing raster art.",
    "No lower stickers, no open-seat pills or labels, no footer.",
    "Both boards use board9.png with K=64; their x/y/w/h include the transparent glow gutter.",
    "Only elements with tint=cyan receive the Friends hue/saturation filter.",
    "CTA people/chevron use brightness(0) as on-gold monochrome treatment; this is independent of the Friends tint.",
    "All plates are reused; no asset or scenery pixels are changed.",
    "schemaVersion 2 uses lane y/h plus explicit capCenterY. It is a design handoff; the application still needs to consume these fields and states. This task changes no application code.",
    "Owner 23.9.2026 (friends-lobby-host-alone): status.heading top 278, status.body 318, status.timer 364, status.clock 362 (his devtools values verbatim); the crown above the host ring removed, the HOST tag (crown inside) takes its place — \"Turhaan kaksi kruunua ja tuo host kyltti on muutenkin väärässä paikassa.\"",
    "Owner 23.9.2026 (friends-lobby-host-alone): sticker.ul left 25 top 142 width 171; sticker.ur left 763 top 143 width 174 (his devtools values verbatim).",
    "Owner 23.9.2026 (friends-lobby-host-alone): the name pill 180×60 centred on the avatar circle with its bottom on the circle's inner bottom (seat 1: left 131 top 620), the name word 24px with its lane 14 below the pill top (634).",
    "Owner 23.9.2026 (friends-lobby-host-alone): HOW TO PLAY / ROOM SETTINGS plates top 1500; gear = the solid gear of the settings head button at 522,1528 w50 (\"miksi on ratas keksitty uudelleen?\"); book icon → fa-solid circle-info at 109,1526 w50 (\"ihan eri maailmasta\"); labels 30px at 165,1534 / 574,1534.",
    "Owner 23.9.2026: \"/var/www/play.saynoway.com/icons on nyt ikonit\" — circle-info-solid.png and gear-solid.png are the pieces (navy sources drawn white by sourceFilter; colour to be confirmed by the owner).",
    "Owner 23.9.2026: a button is one element — its plate's box is the <button> (KitButton); the separate hit targets copy, cta, howto, settings are gone so the tap area cannot drift from the plate.",
    "Owner 23.9.2026 (friends-lobby-host-alone): the people icon by \"Need 1 more player to start\" 270,1429 w50; the caption 337,1440 size 30; INVITE FRIENDS: \"Chevron right on turha, pois.\" Lane sizes are now `size` on the lane (plate-small class gone).",
    "Owner 23.9.2026 (friends-lobby-host-alone): INVITE FRIENDS plate top 1260, its people icon top 1294, its word top 1309 (his devtools values verbatim).",
    "Owner 23.9.2026 (friends-lobby-host-alone): ROOM CODE board 46.5,990 847.5×260; ROOM CODE 150,1036 size 30; code 115,1065 size 90; url 120,1175 size 30; COPY container top 1062, plate width 235, icon left 643 top 1038 and word top 1042 inside the moved container (stage tops = +58.61). Leaves follow the board (+45.5).",
    "Owner 23.9.2026: \"WAITING FOR YOUR CREW boxi ja sen sisältö 20px alaspäin\" — status.* +20.",
    "Owner 23.9.2026: \"Avatareihin liittyvät elementit kaikki 30px alaspäin\" — every seat element, text and hit box +30.",
    "Owner 23.9.2026: the room URL is shown whole — no ellipsis (code.url align left from 120, lane 700 wide).",
    "Owner 23.9.2026: \"HOST pilleri POIS! HOST kruunu ikoni POIS! Mielestäni kruunu symbolisoi pelin voittajaa\" — host variants lose tag.host and its crown; the word HOST alone, 30px, centred on the avatar (seat 1: left 195 top 451 → avatar top − 44).",
    "Owner 23.9.2026: \"Need 1 more player to start\" 7 px left (337 → 330), its icon 5 px left (270 → 265).",
    "Owner 23.9.2026 (friends-lobby-guest): READY loses its pill and sits above the avatar exactly like HOST (30px, centred, avatar top − 44), in its green.",
    "Owner 23.9.2026: HOST and READY words at one height per row — 451 on the top row, 703 on the bottom row — whatever the seat's own avatar box.",
    "Owner 23.9.2026: \"Alempi avatar rivi ja sen elementit 10px alas päin\" — seats 4–6, every element, text and hit box +10 (HOST/READY on that row now 713).",
    "Owner 23.9.2026: \"Laitetaan sittenkin takaisin alempi rivi ja sen elementit eli 10 px ylöspäin\" — seats 4–6 back to where they were; the HOST/READY move under the pill was cancelled (\"perutaan\").",
    "Owner 23.9.2026: \"tuo thumbs fontawesome ikoni laitetaan I'M READY buttoniin ennen tekstiä\" — cta.thumbs in the CTA icon slot; the word uses the icon-offset lane like INVITE FRIENDS.",
    "Owner 23.9.2026: the thumbs-up on I'M READY at left 265 top 1298 width 80 (verbatim).",
    "Owner 23.9.2026: READY = the green ball (Codex round 2, 112×112, top-right of the avatar) with the white thumb inside, 40 px centred; the READY word is gone. HOST unchanged.",
    "Owner 23.9.2026 (Bob, seat 2): ready.badge left 502 top 487 width 80; thumb left 527 top 511 width 28, filter \"invert(1) brightness(1) saturate(3) hue-rotate(90deg)\" — verbatim; as a rule for every seat: ball = avatar right − 64 / avatar top − 16, thumb = ball + (25, 24).",
    "Owner 23.9.2026: \"question-solid josta tehdään Flirt logon värinen vastaava pallo sille, joka ei ole vielä ready\" — occupied (joined, not ready) seats show the same ball turned to the Flirt hue (hue-rotate(170deg): rim 145° → logo 315°) with the question icon inside at the thumb's geometry; the thumb is now the owner's own file.",
    "Owner 23.9.2026: thumb +1,+1 (ball + 26, 25); question +1,+2 (ball + 26, 26).",
    "23.9.2026: the name lane 116 (was 106) so every 8-character name fits the 180 pill — Samantha is 112 px at 24; names are ≤ 8 chars (profile rule)."
  ],
  "auxiliaryStates": {
    "copy_success": {
      "durationMs": 1600,
      "hiddenElements": [
        "copy.icon"
      ],
      "textOverrides": {
        "copy.label": {
          "text": "COPIED",
          "x": 646,
          "w": 142,
          "maxW": 142
        }
      }
    },
    "copy_error": {
      "hiddenElements": [
        "copy.icon"
      ],
      "textOverrides": {
        "copy.label": {
          "text": "RETRY",
          "x": 646,
          "w": 142,
          "maxW": 142
        },
        "code.url": {
          "text": "Copy failed. Try again.",
          "binding": {
            "kind": "literal"
          }
        }
      },
      "hitOverrides": {
        "copy": {
          "action": "copy-room-link",
          "enabled": true
        }
      }
    },
    "sound_off": {
      "elementOverrides": {
        "sound.icon": {
          "piece": "apps/client/public/art/ui-head/icon-sound-off@2x.png"
        }
      },
      "hitOverrides": {
        "sound": {
          "ariaLabel": "Sound off"
        }
      }
    },
    "full_table": {
      "values": {
        "joinedCount": 6,
        "openSeatCount": 0
      },
      "seats": {
        "1": {
          "variant": "host",
          "name": "YOU",
          "avatar": "snw-cast-0056"
        },
        "2": {
          "variant": "ready",
          "name": "Ada",
          "avatar": "snw-cast-0001"
        },
        "3": {
          "variant": "ready",
          "name": "Bob",
          "avatar": "snw-cast-0001"
        },
        "4": {
          "variant": "ready",
          "name": "Cara",
          "avatar": "snw-cast-0001"
        },
        "5": {
          "variant": "ready",
          "name": "Dee",
          "avatar": "snw-cast-0001"
        },
        "6": {
          "variant": "ready",
          "name": "Eli",
          "avatar": "snw-cast-0001"
        }
      },
      "baseState": "host_ready"
    },
    "empty_roster": {
      "values": {
        "joinedCount": 0,
        "openSeatCount": 6
      },
      "seats": {
        "1": {
          "variant": "open",
          "name": "Sami",
          "avatar": "snw-cast-0056"
        },
        "2": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001"
        },
        "3": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001"
        },
        "4": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001"
        },
        "5": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001"
        },
        "6": {
          "variant": "open",
          "name": "YOU",
          "avatar": "snw-cast-0001"
        }
      },
      "textOverrides": {
        "status.heading": {
          "text": "CONNECTING"
        },
        "cta.label": {
          "x": 214,
          "y": 1220,
          "w": 512,
          "h": 70,
          "maxW": 512,
          "capCenterY": 1255,
          "text": "CONNECTING"
        },
        "cta.caption": {
          "text": "Connecting to your room",
          "x": 200,
          "w": 540,
          "maxW": 540
        }
      },
      "hiddenElements": [
        "cta.people",
        "cta.chevron",
        "cta.caption.icon"
      ],
      "elementOverrides": {
        "cta.plate": {
          "brightness": 0.58,
          "opacity": 0.95
        }
      },
      "hitOverrides": {
        "cta": {
          "action": null,
          "enabled": false
        },
        "copy": {
          "action": null,
          "enabled": false
        },
        "seat1": {
          "action": null,
          "enabled": false
        },
        "seat2": {
          "action": null,
          "enabled": false
        },
        "seat3": {
          "action": null,
          "enabled": false
        },
        "seat4": {
          "action": null,
          "enabled": false
        },
        "seat5": {
          "action": null,
          "enabled": false
        },
        "seat6": {
          "action": null,
          "enabled": false
        }
      }
    }
  },
  "stateSelection": {
    "priority": [
      "expired",
      "guest_ready",
      "guest_joined",
      "host_ready",
      "host_waiting"
    ],
    "orthogonal": [
      "copy_success",
      "copy_error",
      "sound_off",
      "full_table",
      "empty_roster"
    ],
    "seatPriority": [
      "host_offline",
      "offline",
      "host",
      "ready",
      "occupied",
      "open"
    ],
    "role": "Host/guest status follows authenticated room state; a guest never gets room-settings/start-match actions."
  },
  "stateDataContract": {
    "fixturesOnly": [
      "values",
      "seats"
    ],
    "runtime": "Actual roster, viewer role, countdown and code come from room state. Never replace the live roster with example fixture data."
  },
  "layoutChangesFromReference": [
    {
      "element": "cta.people",
      "reason": "Reserve 482-wide text lane for the fixed action role; same plate box.",
      "referenceInkBox": {
        "x": 199,
        "y": 1227,
        "w": 78,
        "h": 51
      },
      "deliveredArtBox": {
        "x": 177,
        "y": 1211.5,
        "w": 88,
        "h": 88
      }
    },
    {
      "element": "cta.chevron",
      "reason": "Right clearance for 461-wide INVITE FRIENDS at action=56.",
      "referenceInkBox": {
        "x": 729,
        "y": 1239,
        "w": 18,
        "h": 32
      },
      "deliveredArtBox": {
        "x": 785,
        "y": 1235,
        "w": 30,
        "h": 40
      }
    },
    {
      "element": "settings.icon",
      "reason": "Preserve gaps for ROOM SETTINGS at fixed button=32.",
      "referenceInkBox": {
        "x": 543,
        "y": 1417,
        "w": 45,
        "h": 46
      },
      "deliveredArtBox": {
        "x": 507,
        "y": 1411,
        "w": 56,
        "h": 56
      }
    },
    {
      "element": "settings.label",
      "reason": "Fixed role label is 265.5 wide instead of reference 202; widened within measured plate.",
      "referenceCenterX": 729.5,
      "deliveredCenterX": 715
    },
    {
      "element": "code.value",
      "reason": "Fixed code=100 needs 406-wide ink; reference ink is 324. Lane widened to 430, centre stays 342.",
      "referenceInkWidth": 324,
      "deliveredLaneWidth": 430
    },
    {
      "element": "seat4..6.crown",
      "reason": "Host/host_offline only: crown sits inside upper-right ring arc so it clears row-one name/status tags. These filled lower-row states are absent from the owner's mockup.",
      "placement": "x=centerX+35, y=centerY-90, w=60, h=42.857"
    }
  ],
  "seatInteractionRules": {
    "source": "apps/client/src/screens/Lobby.tsx; existing actions preserved",
    "selection": "First matching rule. Runtime identity uses player IDs, never the displayed YOU label.",
    "rules": [
      {
        "when": "variant == open && !inviteActive",
        "action": null,
        "enabled": false
      },
      {
        "when": "variant == open && inviteActive",
        "action": "invite-friends",
        "enabled": true
      },
      {
        "when": "playerId == viewerId",
        "action": null,
        "enabled": false
      },
      {
        "when": "isHost && playerId != viewerId",
        "action": "confirm-kick-player",
        "enabled": true
      },
      {
        "when": "!isHost && playerId != viewerId",
        "action": "report-player",
        "enabled": true
      }
    ]
  },
  "verification": {
    "pieceHashChecks": 29,
    "mainStates": 5,
    "seatPositions": 6,
    "variantsPerSeat": 6,
    "seatVariantChecks": 36,
    "resolvedViews": 12,
    "textRuns": 48,
    "allTextRunsFit": true,
    "enabledHitOverlaps": 0,
    "smallestHitCssPxAt360": 44.378,
    "roleChecks": "fixed global roles; no per-text cap or font-size overrides",
    "boardChecks": "source slice=128 px on each side; stage border-width=64; fill stretch",
    "expiryGuestChecks": "LEAVE ROOM and report-player preserved; self/open/invite/copy disabled",
    "preview": {
      "file": "art/src/lobby-elements-2026-09-22/preview-layout-friends.png",
      "w": 941,
      "h": 1672,
      "state": "host_waiting",
      "sha256": "270bec609f3d47ebaa13ff1c64f54b365458c250f38d234fb0e6bbe710ef9f50",
      "method": "Existing raster pieces composited at 2x, reduced to 1x; local WOFF2 fonts rasterized with FreeType at fixed role sizes. Not a browser screenshot."
    },
    "mainTextMetrics": [
      {
        "id": "status.heading",
        "role": "eyebrow",
        "fontSize": 26,
        "inkWidth": 433.5,
        "inkHeight": 19.5,
        "capHeight": 19,
        "capCenterY": 296,
        "maxW": 524
      },
      {
        "id": "status.body",
        "role": "body",
        "fontSize": 30,
        "inkWidth": 368.5,
        "inkHeight": 27.5,
        "capHeight": 21.5,
        "capCenterY": 341,
        "maxW": 440
      },
      {
        "id": "status.timer",
        "role": "caption",
        "fontSize": 26,
        "inkWidth": 255.5,
        "inkHeight": 24,
        "capHeight": 19,
        "capCenterY": 384,
        "maxW": 264
      },
      {
        "id": "code.heading",
        "role": "eyebrow",
        "fontSize": 26,
        "inkWidth": 194,
        "inkHeight": 19.5,
        "capHeight": 19,
        "capCenterY": 1002,
        "maxW": 374
      },
      {
        "id": "code.value",
        "role": "code",
        "fontSize": 100,
        "inkWidth": 406,
        "inkHeight": 73.5,
        "capHeight": 71.5,
        "capCenterY": 1058,
        "maxW": 430
      },
      {
        "id": "code.url",
        "role": "caption",
        "fontSize": 26,
        "inkWidth": 352,
        "inkHeight": 24.5,
        "capHeight": 19,
        "capCenterY": 1109,
        "maxW": 412
      },
      {
        "id": "copy.label",
        "role": "button",
        "fontSize": 32,
        "inkWidth": 87.5,
        "inkHeight": 23.5,
        "capHeight": 23,
        "capCenterY": 1061,
        "maxW": 112
      },
      {
        "id": "cta.label",
        "role": "action",
        "fontSize": 56,
        "inkWidth": 461,
        "inkHeight": 44,
        "capHeight": 41.5,
        "capCenterY": 1255,
        "maxW": 482
      },
      {
        "id": "cta.caption",
        "role": "caption",
        "fontSize": 26,
        "inkWidth": 325.5,
        "inkHeight": 24,
        "capHeight": 19,
        "capCenterY": 1355,
        "maxW": 351
      },
      {
        "id": "howto.label",
        "role": "button",
        "fontSize": 32,
        "inkWidth": 232,
        "inkHeight": 23.5,
        "capHeight": 23,
        "capCenterY": 1440.5,
        "maxW": 234
      },
      {
        "id": "settings.label",
        "role": "button",
        "fontSize": 32,
        "inkWidth": 265.5,
        "inkHeight": 23.5,
        "capHeight": 23,
        "capCenterY": 1440.5,
        "maxW": 278
      },
      {
        "id": "seat1.status",
        "role": "status",
        "fontSize": 26,
        "inkWidth": 47.5,
        "inkHeight": 18,
        "capHeight": 18,
        "capCenterY": 684,
        "maxW": 61
      },
      {
        "id": "seat1.name",
        "role": "chip",
        "fontSize": 28,
        "inkWidth": 58,
        "inkHeight": 21,
        "capHeight": 20,
        "capCenterY": 652.5,
        "maxW": 106
      }
    ],
    "measurementUncertainty": {
      "straightNeonRidgeStagePx": 1,
      "circlesAndGlyphCoreStagePx": 2,
      "method": "Measurements exclude diffuse glow; original source ink boxes are retained in measurements."
    },
    "appCodeOrBrowserTestsRun": false
  }
}
